import { createFileRoute } from "@tanstack/react-router";
import { CrudManager } from "@/components/admin/CrudManager";

export const Route = createFileRoute("/admin/paginas")({ component: Page });

function Page() {
  return (
    <CrudManager
      table="pages"
      label="Páginas"
      idColumn="slug"
      slugSource="title"
      fields={[
        { name: "slug", label: "Slug (identificador)", type: "text", required: true },
        { name: "title", label: "Título", type: "text" },
        { name: "content", label: "Conteúdo", type: "richtext" },
        { name: "seo_title", label: "Título SEO", type: "text" },
        { name: "seo_description", label: "Descrição SEO", type: "textarea" },
        { name: "og_image_url", label: "Imagem de compartilhamento", type: "image" },
      ]}
      columns={[
        { key: "slug", label: "Slug" },
        { key: "title", label: "Título" },
      ]}
    />
  );
}
